import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Sparkles, Check } from 'lucide-react';

// Shown at /pricing during the private beta instead of the self-serve
// checkout. Signup stays open (free in beta); public pricing is paused while
// we validate the commercial model. The full PricingPage component is
// untouched, so re-enabling pricing is a one-line route swap. Extra credits /
// pricing questions go to the founder by email.
const BETA_EMAIL = 'tobi@adeystudios.com';
const MAILTO = `mailto:${BETA_EMAIL}?subject=SmartReel%20beta%20access`;

const EXAMPLES = [
  'Property listings from photos',
  'Blog post or thread → video',
  'Fast explainer videos',
  'Team presentations',
];

export default function BetaAccessPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-background/40 py-12 md:py-24">
      <div className="container max-w-xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Card className="p-8 md:p-12 text-center space-y-6">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary mx-auto">
              <Sparkles className="h-4 w-4" />
              Private beta · limited spots
            </div>

            <div className="space-y-3">
              <h1 className="text-3xl md:text-4xl font-semibold">
                Get early access to SmartReel
              </h1>
              <p className="text-base text-muted-foreground max-w-[460px] mx-auto">
                The fastest way to turn photos and ideas into short, narrated
                videos. Create real content and help shape what we build next.
              </p>
            </div>

            <ul className="space-y-2 max-w-[320px] mx-auto text-left">
              {EXAMPLES.map((example) => (
                <li
                  key={example}
                  className="flex items-center gap-2 text-sm text-muted-foreground"
                >
                  <Check className="h-4 w-4 shrink-0 text-primary" />
                  {example}
                </li>
              ))}
            </ul>

            <div className="space-y-2 pt-2">
              <Link to="/auth">
                <Button size="lg">Sign up for beta access</Button>
              </Link>
              <p className="text-sm text-muted-foreground">Free while we're in beta.</p>
            </div>

            <p className="text-xs text-muted-foreground border-t pt-4">
              Need more credits or pricing?{' '}
              <a href={MAILTO} className="font-medium text-primary hover:underline">
                Email {BETA_EMAIL}
              </a>
            </p>
          </Card>
        </motion.div>
      </div>
    </div>
  );
}
